import React from 'react';
import MainLayout from '../../components/MainLayout';
import { useTranslation } from '../../context/LanguageContext';
import ManagementHeader from '../management/ManagementHeader';
import SystemTabs from './SystemTabs';
import '../management/management.css';

/* 시스템 관리 > IP 관리.
 * 접근 IP 제한은 백엔드에 API·테이블이 아직 없다. 예전 화면은 코드에 적어 둔 IP 5개와 접속 시각을 보여 주고
 * 추가해도 브라우저 안에서만 늘어났다(저장·차단 안 됨). 운영 화면에 목업을 쓰지 않는 원칙에 따라
 * 목록은 비워 두고, 서버 기능이 없다는 안내와 표의 틀만 보여 준다. 기능을 붙일 때 이 파일에 조회·등록 API 를 연결한다. */
function IPManagementPage() {
  const { t } = useTranslation();
  const columns = ['ip', 'description', 'access', 'status', 'lastAccess', 'createdAt', 'createdBy', 'actions'];

  return (
    <MainLayout>
      <div className="mg-page">
        <ManagementHeader rootLabel={t('sidebar.system.title')} icon="settings" crumbs={[{ label: t('pages.system.management.tabs.ip') }]}>
          <button type="button" className="mg-btn primary" disabled title={t('pages.system.ip.notReady.title')}>
            <span className="material-symbols-outlined">add</span>
            {t('pages.system.ip.controls.addBtn')}
          </button>
        </ManagementHeader>
        <SystemTabs active="ip" />

        <div className="mg-panel fill">
          <div className="mg-notice" role="status">
            <span className="material-symbols-outlined">info</span>
            <p>
              <strong>{t('pages.system.ip.notReady.title')}</strong>
              <br />
              {t('pages.system.ip.notReady.body')}
            </p>
          </div>

          <div className="mg-table-wrap">
            <table className="mg-table">
              <thead>
                <tr>
                  {columns.map((c) => <th key={c} className={c === 'ip' || c === 'description' ? 'left' : ''}>{t(`pages.system.ip.table.${c}`)}</th>)}
                </tr>
              </thead>
              <tbody>
                <tr className="mg-empty-row">
                  <td className="mg-empty" colSpan={columns.length}>{t('pages.system.ip.notReady.empty')}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default IPManagementPage;
